import { fetchData } from '../utils'
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Table, Button, Select, Tabs, Row, Col, message } from 'antd';
import * as React from "react";
import * as AuthStore from "../store/Auth";

const { Option } = Select;
const { TabPane } = Tabs;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class PVLS extends React.Component<AuthProps>
{
    public state =
    {
       
        statesLoaded: false,
        loadingOth: false,
        site: { id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
        state: { id: 0, name: '', code: '', sites: [] },
        data: [],
        pagination:
        {
            current: 1,
            total: 0,
            pageSize: 100000,
            sorter:
            {
                field: "name",
                order: "asc"
            }
        },
        states: [],
        sites: [],
        loading: false,
        confirmLoading: false,
        fLoading: false,
        title: 'New Site',
            searchText: ""
    };

    async componentDidMount()
    {
        let el = this;
        let user = this.props.appUser;

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        if (user.stateCode && user.stateCode.length > 0)
        {
            var statex = states.filter(s =>
            {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0)
            {
                let state: any = states[0];
                this.setState({ state });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
    }
    selectSite(value: any)
    {
        if (value)
        {
            let sites: any = this.state.state.sites.filter(function (o: any) { return o.id === value.key });   
            console.log(sites[0]);
            this.setState({ site: sites[0] });
        }
    }
    selectState(value: any)
    {
        var el = this;
        if (!value)
        {
            return;
        }
       
        if (value)
        {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0)
            {
                var state = states[0];
                el.setState({ state: state });
            }
        }
    }

    async getItems()
    {        
        let el = this;
        if (!el.state.site.id || el.state.site.id.length < 1)
        {
            message.error('Please select a Facility');
            return;
        }

        this.setState({ loading: true });
        var query = `/api/Stats/getDueForPVLS?site=${el.state.site.id}`;

        let res = await fetchData(query);

        el.setState({
            data: res,
            loading: false
        });
    }
    render()
    {
        const columns =
            [
                {
                    title: 'Facility',
                    dataIndex: 'facility',
                    key: 'facility',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Patient Id',
                    dataIndex: 'patientId',
                    key: 'patientId',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Hospital Number',
                    dataIndex: 'hospitalNumber',
                    key: 'hospitalNumber',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Date Of Birth',
                    dataIndex: 'dateOfBirth',
                    key: 'dateOfBirth',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value.replace('T00:00:00', '') : ''}</span>
                },
                {
                    title: 'Sex',
                    dataIndex: 'sex',
                    key: 'sex',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'ART Start Date',
                    dataIndex: 'artStartDate',
                    key: 'artStartDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value.replace('T00:00:00', '') : ''}</span>
                },
                 {
                     title: 'Last Pick up Date',
                     dataIndex: 'lastDrugPickup',
                     key: 'lastDrugPickup',
                     render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value.replace('T00:00:00', '') : ''}</span>
                },
                {
                    title: 'Current Days Of ARV Refill',
                    dataIndex: 'lastDaysOfARVRefill',
                    key: 'lastDaysOfARVRefill',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Last Sample Collection Date',
                    dataIndex: 'sampleCollectionDate',
                    key: 'sampleCollectionDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value.replace('T00:00:00', '') : ''}</span>
                },
                {
                    title: 'Last Viral Load Result',
                    dataIndex: 'viralLoadResult',
                    key: 'viralLoadResult',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                }
        ];
     
        const { loading, state, states } = this.state;                      
        let user = this.props.appUser;

        return (
            <div className="site-top">
                <Helmet>
                    <title>CDR - Clients Due PVLS</title>
                </Helmet>
                <div className="custom-filter-dropdown">
                    <br/>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Clients Due For PVLS</h4>
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={2}>
                        {!user.stateCode &&
                            <Col xs={24} sm={24} md={8} lg={8}>
                                <Select
                                labelInValue className="top-10-margin"
                                    showSearch
                                    optionFilterProp="children"
                                    disabled={loading}
                                style={{ width: '100%', float: 'left' }}
                                    placeholder="Select State"
                                    onChange={(value) => this.selectState(value)}
                                >
                                    <Option key="" value="">-- Select State --</Option>
                                {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                </Select>
                            </Col>
                        }
                        <Col xs={24} sm={24} md={8} lg={8}>
                            <Select
                                labelInValue className="top-10-margin"
                                showSearch
                                optionFilterProp="children"
                                disabled={loading}
                                style={{ width: '100%', float: 'right' }}
                                placeholder="Select Facility"
                                onChange={(value) => this.selectSite(value)}
                            >
                                <Option key="" value="">-- Select Facility --</Option>
                                {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Button disabled={loading} className="login-button top-10-margin" id="push-btn" loading={loading} key="submit" type="primary" size="large" onClick={() => this.getItems()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'right', width:'95%' }}>
                                <span id="buttonText">{!loading? 'Fetch Data' : 'Please wait...'}</span>
                            </Button>
                        </Col>
                    </Row>
                    <br />                    
                    <Row>
                        <Col span={24} className="ant-modal-footer si-ant" style={{overflow: 'scroll'}}>
                            <br />
                            <Table columns={columns} rowKey={record => record.patientId} dataSource={this.state.data} loading={this.state.loading} bordered />
                        </Col>
                    </Row>  

                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(PVLS as any);
